import React, { CSSProperties } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function CustomCarousel(props: any) {
	const { className = "presentation-mode", ...restProps } = props;
	return (
		<Carousel
			className={`custom-carousel ${className}`}
			showThumbs={false}
			showStatus={false}
			transitionTime={1000}
			interval={3000}
			showArrows={false}
			// animationHandler={'fade'}
			// swipeable={false}
			// infiniteLoop={true}
			// dynamicHeight={true}
			// autoFocus={true}
			// useKeyboardArrows
			renderIndicator={(onClickHandler, isSelected, index, label) => {
				if (isSelected) {
					return (
						<li
							style={{
								...indicatorStyles,
								background: "var(--primary)",
								width: "24px",
								borderRadius: "8px",
							}}
							aria-label={`Selected: ${label} ${index + 1}`}
							title={`Selected: ${label} ${index + 1}`}
						/>
					);
				}
				return (
					<li
						style={indicatorStyles}
						onClick={onClickHandler}
						value={index}
						key={index}
						role="button"
						tabIndex={0}
						title={`${label} ${index + 1}`}
						aria-label={`${label} ${index + 1}`}
					/>
				);
			}}
			{...restProps}
			autoPlay={false}
		>
			{props.children}
		</Carousel>
	);
}

const indicatorStyles: CSSProperties = {
	background: "#fff",
	width: 8,
	height: 8,
	borderRadius: "50%",
	display: "inline-block",
	margin: "0 6px",
};
